import React from 'react';
import PropTypes from 'prop-types';

function SquareButton({ active, activeColor, color }) {
  return (
    <>
      <path
        d="M577.117 214.34C577.117 225.614 567.972 234.754 556.701 234.754C545.426 234.754 536.286 225.614 536.286 214.34C536.286 203.064 545.426 193.924 556.701 193.924C567.972 193.924 577.117 203.064 577.117 214.34Z"
        fill={active ? activeColor : color}
      />
      <path
        d="M546.252 224.952H567.165V204.037H546.252V224.952ZM569.01 227.413H543.792V202.191H569.01V227.413Z"
        fill="#FF92E0"
      />
    </>
  );
}

SquareButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

SquareButton.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#464A56',
};

export default SquareButton;
